import http from '../../axios';
import {Player} from "@/store/player/types";
import PlayerStore from "@/store/player";
import {ChainTaskInfo, EventRewardDto, EventRewardPosition, EventRewardType, HintDto} from "@/store/task/types";
import {ClanTaskOption} from "@/store/clan/types";

export default class TaskStore {

    public static fetchChainTaskInfo(taskId: string): Promise<ChainTaskInfo> {
        return http.get('/api/task/chain/' + taskId + '/info')
            .then(r => r.data)
            .then(tiObj => {
                let ti: ChainTaskInfo = Object.assign(new ChainTaskInfo(), tiObj);
                return ti;
            });
    }

    public static completeTask(id: string): Promise<Player> {
        return http.post('/api/task/' + id + '/complete')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static setTasksSeen(): Promise<Player> {
        return http.post('/api/task/set/seen')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static setNewTaskSeen(): Promise<Player> {
        return http.post('/api/task/set/new/seen')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static setHintSeen(): Promise<Player> {
        return http.post('/api/task/set/hint/seen')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static deleteHint(): Promise<Player> {
        return http.post('/api/task/delete/hint')
            .then(r => r.data)
            .then(playerObj => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static getHint(): Promise<HintDto> {
        return http.get('/api/task/get/hint')
            .then(r => r.data)
            .then(hintObj => {
                let hint: HintDto = Object.assign(new HintDto(), hintObj);
                return hint;
            });
    }

    public static fetchRatingPositionByEvent(): Promise<number> {
        return http.get('/api/rating/position/by/event')
            .then(r => r.data)
            .then(obj => {
                return Number(obj);
            });
    }

    public static fetchEventRewardsInfo(): Promise<EventRewardPosition[]> {
        return http.get('/api/task/get/event/rewards')
            .then(r => r.data)
            .then(pObj => {
                let res: EventRewardPosition[] = [];
                res = Object.assign([], pObj);
                return res;
            });
    }

    public static tryToTakeEventReward(): Promise<EventRewardDto[]> {
        return http.get('/api/task/take/event/reward')
            .then(r => r.data)
            .then(pObj => {
                let res: EventRewardDto[] = [];
                res = Object.assign([], pObj);
                return res;
            });
    }
}
